<template>
  <section class="register">
    <div class="box" style="max-width: 1000px">
      <div class="header">
        <div class="title">Visualizar</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="preview">
        <Show :id="show" :businessUrl="business" :preview="true" />
      </div>
    </div>
  </section>
</template>

<script>
import Show from '../../main/component/Show.vue'

export default {
  name: 'showPreview',

  props: ['show', 'business', 'close'],
  components: { Show }
}
</script>

<style lang="scss" scoped>
.preview {
  height: calc(100vh - 200px);
  margin: 0 15px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
